function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';

import { Icon } from "../../Layout";

const composeIcon = (data) =>
typeof data.value === 'string' && data.icon !== undefined ? /*#__PURE__*/
React.createElement(React.Fragment, null, /*#__PURE__*/
_jsx(Icon, { data: data.icon }), /*#__PURE__*/
_jsx("span", {}, void 0, "\xA0")
) :
null;

const composeCount = (data, key) => {
  if (data.valueCount > 1) {
    return /*#__PURE__*/(
      _jsx(React.Fragment, {}, key,
      composeIcon(data),
      data.value, "\xA0", /*#__PURE__*/

      _jsx("span", { className: "item-count" }, void 0, data.valueCount)
      ));

  }
  return /*#__PURE__*/(
    React.createElement(React.Fragment, null,
    composeIcon(data),
    data.value
    ));

};

const renderItemValue = (v, key, i) => /*#__PURE__*/
_jsx("li", { className: "item-value" }, key,
composeCount(v, `item-value-${i}`)
);


const renderList = (prop) => /*#__PURE__*/
_jsx("ul", { className: "multiline" }, void 0,
prop.value.map((v, index) => {
  const key = `${prop.name}_${index}`;
  return renderItemValue(v, key, index);
})
);


const renderCompact = (prop) => /*#__PURE__*/
_jsx("ul", { className: "compact comma-separated" }, void 0, prop.value.map((v, i) => renderItemValue(v, i, i)));


const groupRepeatedValues = (property) =>
property.value.reduce((results, v) => {
  const previousValue = results.find((r) => r.value === v.value);
  if (previousValue) {
    previousValue.valueCount += 1;
  } else {
    results.push(_objectSpread(_objectSpread({}, v), {}, { valueCount: 1 }));
  }
  return results;
}, []);

const ValueList = ({ property, compact }) => {
  const propertyWithGroupedValues = _objectSpread(_objectSpread({}, property), {}, { value: groupRepeatedValues(property) });
  return compact ? renderCompact(propertyWithGroupedValues) : renderList(propertyWithGroupedValues);
};

export default ValueList;